<template>
  <div class="TipsInput tipsEle">
    <input
      ref="input"
      type="text"
      :placeholder="placeholder"
      v-model="inputText"
      class="tipsEle"
      @keyup.enter="handleEnter"
    />
    <ul class="tipsBox tipsEle" v-show="tipsShow">
      <li
        v-for="(item, index) in tips"
        :key="index"
        @click="tipsClickHandle(item)"
        class="tipsEle"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TipsInput",
  computed: {
    tipsShow() {
      if (this.inputText.trim().length > 0 && this.inputBoxFocus) {
        return true;
      } else {
        return false;
      }
    },
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      inputText: "",
      inputBoxFocus: false,
      tips: [],
    };
  },
  mounted() {
    document.addEventListener("click", this.documentClickHandle, false);
  },
  destroyed() {
    document.removeEventListener("click", this.documentClickHandle, false);
  },
  methods: {
    tipsClickHandle(tip) {
      this.$emit("tipsChosen", tip);
    },
    documentClickHandle(e) {
      if (e.target && e.target.className && typeof e.target.className === 'string' && e.target.className.includes("tipsEle")) {
        this.inputBoxFocus = true;
      } else {
        this.inputBoxFocus = false;
      }
    },
    handleEnter() {
      this.$emit("handleEnter");
    },
  },
  watch: {
    inputText(newVal, oldVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/var.less";

.TipsInput {
  position: relative;
  width: 254px;
  display: inline-block;

  input {
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    padding: 0 12px;
    width: 100%;
    height: 38px;
    font-size: 13px;
    color: #1e293b;
    outline: none;
    transition: all 0.2s ease;

    &:focus {
      border-color: @brandPrimary;
      box-shadow: 0 0 0 3px rgba(15, 82, 186, 0.12);
    }
  }

  .tipsBox {
    position: absolute;
    top: 44px;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
    list-style: none;
    padding: 4px 0;
    margin: 0;
    z-index: 100;

    li {
      text-align: left;
      width: 100%;
      height: 32px;
      line-height: 32px;
      padding: 0 12px;
      font-size: 13px;
      color: #334155;
      cursor: pointer;
      transition: all 0.15s ease;

      &:hover {
        background-color: #eff6ff;
        color: @brandPrimary;
        font-weight: 500;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TipsInput.vue